import { Power0, TweenMax } from "gsap";
import { AddMouseDownListener, Log, LogGroup, Rect } from "../.././MyHelpers";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { StateChange, StateMachine } from "../StateMachine";
import { FreegamePick, FreegamePickElementParams } from "./FreegameBonus";

export enum FGPickElemState {
	Idle,
	WaitToPick,
	NotPicked,           Picked,
	WaitDisplayRemainig, WaitDisplayAward,
	DisplayRemaining,    DisplayAward,
						 
}

export type FreegamePickCallback = (index: number) => void;
export type FreegamePickAwardDisplayedCallback = (index: number) => void;
export type FreegameRemainingDisplayedCallback = (index: number) => void;

export class FreegamePickElement {
	protected index: number = 0;

	protected sprite: CanvasSprite = null;
	protected displayRect: Rect = null;
	protected pickRect: Rect = null;
	protected awardRect: Rect = null;
	
	protected anim_waitpick: TweenMax = null; // gsap tweenmax
	protected anim_bringfront: TweenMax = null; // gsap tweenmax
	protected anim_pushback: TweenMax = null; // gsap tweenmax
	protected anim_awardZoomIn: TweenMax = null; // gsap tweenmax
	protected myscale: number = 1;

	protected view: HTMLElement = null;
	public pickElem: HTMLElement = null;
	public awardElem: HTMLElement = null;


	protected stateMachine: StateMachine<FGPickElemState> = null;
	protected pickCallback: FreegamePickCallback = null;

	protected award: FreegamePick = null;

	protected logGroup: LogGroup = null;

	protected award_animEnded: boolean = false;
	protected award_set: boolean = false;

	

	// remaining reveal must be requested
	private remainining_requestReveal: boolean = false;

	//public constructor(logGroup: LogGroup, index: number, displayRect: PixelRect, pickRect: PixelRect, awardRect: PixelRect, sprite: CanvasSprite) {
	public constructor(params: FreegamePickElementParams) {

		this.index = params.index;
		this.logGroup = params.logGroup.Add(["FreegamePickElement", "" + this.index]);
		this.stateMachine = new StateMachine<FGPickElemState>(FGPickElemState.Idle, this.logGroup, (state: FGPickElemState) => {return FGPickElemState[state];});

		this.stateMachine.SetCallback(FGPickElemState.WaitToPick, StateChange.Begin, () => this.OnWaitToPickBegin());

		this.stateMachine.SetCallback(FGPickElemState.Picked, StateChange.Begin, () => this.OnPickedBegin());
		this.stateMachine.SetCallback(FGPickElemState.WaitDisplayAward, StateChange.Begin, () => this.OnWaitDisplayAwardBegin());
		this.stateMachine.SetCallback(FGPickElemState.DisplayAward, StateChange.Begin, () => this.OnDisplayAwardBegin());

		this.stateMachine.SetCallback(FGPickElemState.NotPicked, StateChange.Begin, () => this.OnNotPickedBegin());
		this.stateMachine.SetCallback(FGPickElemState.WaitDisplayRemainig, StateChange.Begin, () => this.OnWaitDisplayRemainingBegin());
		this.stateMachine.SetCallback(FGPickElemState.DisplayRemaining, StateChange.Begin, () => this.OnDisplayRemainingBegin());

		this.displayRect = params.displayRect;
		this.pickRect = params.pickRect;
		this.awardRect = params.awardRect;
		
		this.sprite = params.sprite;

		
		this.AnimPrepare();

		this.sprite.canvas.context.shadowBlur = 35;
		this.sprite.canvas.context.shadowColor = "yellow";
		this.sprite.AddOnCompleteCallback(() => this.OnSpriteComplete());

		this.view = document.createElement("div");
		this.view.style.position = "absolute";
		this.view.style.left = this.displayRect.x + "px";
		this.view.style.top = this.displayRect.y + "px";
		this.view.style.width = this.displayRect.width + "px";
		this.view.style.height = this.displayRect.height + "px";
		this.view.style.pointerEvents = "none";

		// pick element usually little smaller than images, because images can overlap,
		// but we don't want pick areas to overlap!
		this.pickElem = document.createElement("div");
		this.pickElem.classList.add("pick");
		this.pickElem.style.position = "absolute";
		this.pickElem.style.left = (this.pickRect.x/* - this.displayRect.x*/) + "px";
		this.pickElem.style.top = (this.pickRect.y/* - this.displayRect.y*/) + "px";
		this.pickElem.style.width = this.pickRect.width + "px";
		this.pickElem.style.height = this.pickRect.height + "px";
		this.pickElem.style.pointerEvents = "auto";

		AddMouseDownListener(this.pickElem, () => this.Picked());

		// pick debug
		//this.pickElem.style.border = "1px solid blue";
		//this.pickElem.innerHTML = "index: " + this.index;
		this.AwardElemePrepare();

		this.anim_awardZoomIn = TweenMax.fromTo(this.awardElem, 0.125, {scale: 0.1}, {scale: 1, paused: true});

		this.view.appendChild(this.sprite.View());
		this.view.appendChild(this.pickElem);
		this.view.appendChild(this.awardElem);
	}

	public AwardElemePrepare()
	{
		this.awardElem = document.createElement("div");
		this.awardElem.classList.add("award");
		this.awardElem.style.position = "absolute";
		this.awardElem.style.left = (this.awardRect.x/* - this.displayRect.x*/) + "px";
		this.awardElem.style.top = this.awardRect.y + "px";
		this.awardElem.style.width = this.awardRect.width + "px";
		this.awardElem.style.height = this.awardRect.height + "px";
		//this.awardElem.style.fontSize = "120px";
		this.awardElem.style.webkitTextStroke = "2px";
		this.awardElem.style.webkitTextStrokeColor = "black";

		//this.awardElem.style.border = "1px solid green";
		this.awardElem.style.visibility = "hidden";
	}



	protected PreparePickedElement() : void
	{

	}

	protected PrepareRemainingElement(): void
	{

	}

	public PickRect(): Rect
	{
		return this.pickRect;
	}

	public DisplayRect(): Rect
	{
		return this.displayRect;
	}

	protected AnimPrepare(): void {
		this.WaitPickAnimPrepare();

		this.anim_bringfront = TweenMax.to(this, 1, {myscale: 1, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayAward)});
		this.anim_pushback = TweenMax.to(this, 1, {myscale: 0.65, ease: Power0.easeNone, paused: true, onComplete: () => this.stateMachine.ChangeState(FGPickElemState.WaitDisplayRemainig)});
	}

	protected WaitPickAnimPrepare(): void {
		this.anim_waitpick = TweenMax.fromTo(this, 1, {myscale: 0.8}, {myscale: 0.85, yoyo: true, repeat: -1, ease: Power0.easeNone, paused: true});
	}

	public BringToFront() {
		this.stateMachine.ChangeState(FGPickElemState.Picked);
	}

	public PushToBack() {
		this.stateMachine.ChangeState(FGPickElemState.NotPicked);
	}

	private Picked() {
		// Log.Debug(this.logGroup, "Picked");

		if (this.stateMachine.State() == FGPickElemState.WaitToPick)
		{
			if (this.pickCallback != null) {
				this.pickCallback(this.index);
			}
		}
		else
		{
			// not allowed to pick
		}
	}

	public Start(): void {
		//debugger;

		this.Reset();
		this.stateMachine.ChangeState(FGPickElemState.WaitToPick);
	}

	public Reset(): void {

		// Log.Debug(this.logGroup, "Resetting");

		this.awardElem.innerHTML = "";
		this.awardElem.style.visibility = "hidden";
		this.awardElem.classList.remove("award-remaining");
		this.sprite.Reset();
		this.sprite.Update();
		this.award = null;
		this.remainining_requestReveal = false;
		this.myscale = 1;
		this.Update();
	}

	public Update(): void {
		//debugger;ć
		this.sprite.Scale(this.myscale);
		this.sprite.Update(true);
	}

	public View(): HTMLElement {
		return this.view;
	}

	public AddPickCallback(callback: FreegamePickCallback): void {
		this.pickCallback = callback;
	}

	// award
	public SetAward(award: FreegamePick): void {
		this.award = award;
		this.awardElem.innerHTML = "" + this.award.Award;

		this.TryDisplayAward();
	}

	private TryDisplayAward(): void {
		
		if (this.stateMachine.State() == FGPickElemState.WaitDisplayAward && this.award != null) {
			this.stateMachine.ChangeState(FGPickElemState.DisplayAward);
		}
	}

	// remaining
	public SetRemaining(award: FreegamePick): void {
		//debugger;
		this.award = award;
		this.awardElem.innerHTML = "" + this.award.Award;
		this.TryDisplayRemaininig();
	}

	// display remaining, if all conditions are met
	private TryDisplayRemaininig(): void {
		if (this.stateMachine.State() == FGPickElemState.WaitDisplayRemainig && 
			this.award != null && 
			this.remainining_requestReveal) 
		{
			this.stateMachine.ChangeState(FGPickElemState.DisplayRemaining);
		}
	}


	public CurrentState(): FGPickElemState {
		return this.stateMachine.State();
	}

	// callback - award has been displayed
	private displayedCallbacks: FreegamePickAwardDisplayedCallback[] = [];
	public  AddFreegamePickAwardDisplayedCallback(callback: FreegamePickAwardDisplayedCallback): void {
		this.displayedCallbacks.push(callback);
	}

	private OnAwardDisplayed() {
		// Log.Debug(this.logGroup, "Award has been displayed");

		for (let i = 0; i < this.displayedCallbacks.length; i++) {
			this.displayedCallbacks[i](this.index);
		}
	}

	// Command to reveal remaining
	public RevealRemaining() {
		//debugger;
		if (this.stateMachine.State() == FGPickElemState.WaitDisplayRemainig) {
			this.awardElem.classList.add("award-remaining");
			this.remainining_requestReveal = true;
			this.TryDisplayRemaininig();
		}
		else {
			debugger;
			Log.Error(this.logGroup, "Wrong state to reveal remaining, current state: " + FGPickElemState[this.stateMachine.State()] + ", required state: " + FGPickElemState[FGPickElemState.WaitDisplayRemainig]);
		}
	}

	// callback - remainig has been displayed
	private remainingCallbacks: FreegameRemainingDisplayedCallback[] = [];
	public AddRemainingDisplayedCallback(callback: FreegameRemainingDisplayedCallback): void {
		this.remainingCallbacks.push(callback);
	}

	private OnRemainingDisplayed(): void {
		// Log.Debug(this.logGroup, "Remaining has been displayed");

		for (let i = 0; i < this.remainingCallbacks.length; i++) {
			this.remainingCallbacks[i](this.index);
		}
	}


	// reveal sprite has finished, the award/remaining is now visible
	private OnSpriteComplete(): void {
		if (this.stateMachine.State() == FGPickElemState.DisplayAward) {
			// finished displaying award
			this.OnAwardDisplayed();
		}
		else {
			// finished displaying remaining
			this.OnRemainingDisplayed();
		}
	}

	// states

	// waiting for pick
	protected OnWaitToPickBegin(): void {
		// Log.Debug(this.logGroup, "Starting wait pick anim");
		this.anim_waitpick.restart();
	}

	// either picked...
	protected OnPickedBegin(): void {
		// bring to front
		// Log.Debug(this.logGroup, "Bringing to front");

		this.anim_waitpick.kill();
		this.anim_bringfront.restart();
	}

	// picked, try to display award
	private OnPickedEnd(): void {
		// Log.Debug(this.logGroup, "Bringing to front finished");

		this.award_animEnded = true;
		this.TryDisplayAward();
	}

	// ... or not picked
	protected OnNotPickedBegin(): void {
		// push to back
		// Log.Debug(this.logGroup, "Sending to back");

		this.anim_waitpick.kill();
		this.anim_pushback.restart();
	}

	private OnNotPickedEnd(): void {
		// Log.Debug(this.logGroup, "Sending to back finished");

		this.award_animEnded = true;
	}

	// waiting for award to be displayed
	private OnWaitDisplayAwardBegin(): void {
		this.TryDisplayAward();
	}

	// displaying award
	private OnDisplayAwardBegin(): void {
		// Log.Debug(this.logGroup, "Displaying award");
		this.PreparePickedElement();
		this.sprite.Start(false);

		setTimeout(() => {
			//debugger;
			this.awardElem.style.visibility = "visible";
			this.anim_awardZoomIn.restart();

			if (this.OnDisplayAwardCallback != null)
				this.OnDisplayAwardCallback();

		}, 250);
	}

	public OnDisplayAwardCallback: (() => void) = null;
	public OnDisplayRemainingCallback: (() => void) = null;


	// waiting for remaining to be displayed 
	private OnWaitDisplayRemainingBegin(): void {
		this.TryDisplayRemaininig();
		//this.sprite.Start(false);
		//this.awardElem.style.visibility = "visible";
	}

	// displaying remaining
	private OnDisplayRemainingBegin(): void {
		// Log.Debug(this.logGroup, "Displaying remaining");
		this.PrepareRemainingElement();
		this.sprite.Start(false);
		//this.awardElem.style.visibility = "visible";
		setTimeout(() => {
			this.awardElem.style.visibility = "visible";
			this.anim_awardZoomIn.restart();

			if (this.OnDisplayRemainingCallback != null)
				this.OnDisplayRemainingCallback();
		}, 700);
	}

}